import { useActionState } from "react";
import { updateTagAction } from "@/actions/tags";
import { Button } from "@/components/Button";
import { FormCell, FormSelectCell, StaticCell } from "@/components/FormCell";
import styles from "@/components/FormRow.module.css";
import { LinkButton } from "@/components/LinkButton";
import { initialFormState } from "@/lib/formState";
import { useFormRedirect } from "@/lib/useFormRedirect";
import { TAG_KINDS } from "@shared/validation";

const FORM_ID = "tag-edit";

type TagEditRowProps = {
  // The listing owns the rows, so a save has to tell it to read again.
  onSaved: () => void;
  slug: string;
  label: string;
  kind: string;
};

export const TagEditRow = ({ onSaved,
  slug, label, kind }: TagEditRowProps) => {
  const [state, formAction, isPending] = useActionState(
    updateTagAction.bind(null, slug),
    initialFormState,
  );

  useFormRedirect(state, onSaved);

  return (
    <>
      <StaticCell value={slug} isRowHeader />
      <FormCell
        form={FORM_ID}
        name="label"
        label="Label"
        defaultValue={state.values.label ?? label}
        errors={state.fieldErrors.label}
      />
      <FormSelectCell
        form={FORM_ID}
        name="kind"
        label="Kind"
        options={TAG_KINDS}
        defaultValue={state.values.kind ?? kind}
        errors={state.fieldErrors.kind}
      />
      {/* State and the actions column: read-only while editing. */}
      <td className={styles.actions} colSpan={2}>
        {/* A form may not be a child of tbody, but it may sit inside a cell —
            the inputs above associate to it by id. */}
        <form id={FORM_ID} action={formAction} hidden />
        <Button
          type="submit"
          form={FORM_ID}
          variant="primary"
          disabled={isPending}
        >
          {isPending ? "Saving..." : "Save"}
        </Button>
        <LinkButton href="/tags" variant="secondary" shouldReplaceHistory>
          Cancel
        </LinkButton>
      </td>
    </>
  );
};
